import { HubBackLink } from '@/components/hub/HubBackLink';
import { SystemStatus } from '@/components/dashboard/SystemStatus';

export function ServerStatusPage() {
  return (
    <div className="lms-server-status lms-site-admin-hub-page font-sans">
      <header className="mb-6 flex items-start gap-4">
        <HubBackLink to="/administracion?tab=development" label="Volver a Administración" />
        <div className="min-w-0">
          <h1 className="text-3xl font-semibold text-dash-primary md:text-4xl">Estado del sistema</h1>
          <p className="mt-1 max-w-2xl text-dash-on-surface-variant">
            Rendimiento del servidor en tiempo real
          </p>
        </div>
      </header>

      <SystemStatus />
    </div>
  );
}
